import Lenis from "lenis";

let lenis = null;

export function initLenis() {
    if (
        typeof window !== "undefined" &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
        return null;
    }
    lenis = new Lenis({
        duration: 1.15,
        smoothWheel: true,
    });
    const raf = (time) => {
        lenis.raf(time);
        requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return lenis;
}

export function scrollToSection(hash) {
    const el = document.querySelector(hash);
    if (!el) return;
    if (lenis) {
        const y = el.getBoundingClientRect().top + window.scrollY;
        lenis.scrollTo(y, { duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
}

export function destroyLenis() {
    if (lenis) {
        lenis.destroy();
        lenis = null;
    }
}
